export default "\n<div class=\"loader-content\">\n  <span class=\"loader\"></span>\n</div>";